"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/utils/defaultPreflightHandler.ts
async function defaultPreflightHandler(args) {
  if (typeof args.options.body === "object") {
    args.options.body = JSON.stringify(args.options.body);
    args.options.headers ??= {
      "Content-Type": "application/json"
    };
  }
}


exports.default = defaultPreflightHandler;

module.exports = exports.default;
